import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useAuthStore from "../../store/authStore";

/**
 * Landing page after SSO redirect.
 * URL: /auth/callback?token=<jwt>&refresh=<token>
 */
export default function CallbackPage() {
  const [params] = useSearchParams();
  const { loginWithToken } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get("token");
    const refresh = params.get("refresh");
    if (token) {
      loginWithToken(token, refresh);
      navigate("/dashboard", { replace: true });
    } else {
      navigate("/login?error=sso_failed", { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <p className="text-gray-500 animate-pulse">Signing you in…</p>
    </div>
  );
}
